import { babyface } from '../CDNUrl';

const EVENT_BANNER_URI = `${babyface}/event/event_banner`;
const EVENT_DETAIL_URI = `${babyface}/event_detail`;
const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const EVENT_BANNER_MIRAEASSET = {
  src: `${EVENT_BANNER_URI}_miraeasset.jpg`,
  alt: `미래에셋증권 x 베이비페이스 이벤트 배너`,
};

export const EVENT_DETAIL_MIRAEASSET = {
  src: `${EVENT_DETAIL_URI}/miraeasset.jpg`,
  alt: `미래에셋증권 x 베이비페이스 이벤트 안내사항`,
}

export const EVENT_DETAIL_MIRAEASSET_BUTTONS = [
  {
    src: `${EVENT_DETAIL_URI}/miraeasset_button_01.png`,
    alt: '미래에셋증권 x 베이비페이스 이벤트 신청 버튼 1',
  },
  {
    src: `${EVENT_DETAIL_URI}/miraeasset_button_02.png`,
    alt: '미래에셋증권 x 베이비페이스 이벤트 신청 버튼 2',
  },
];

export const HOME_BANNER_MIRAEASSET = {
  src: `${HOME_BANNER_URI}_miraeasset.jpg`,
  alt: `미래에셋증권 x 베이비페이스 이벤트 홈배너`,
};
